import "./Deals.module.css";
import Header from "@/reusable_sections/Header";
import InstagramPromoStrip from "./sections/InstagramPromoStrip";
import Footer from "@/reusable_sections/Footer";
import DealsAndSpecialsShowcase from "./sections/DealsAndSpecialsShowcase";
export default function DealsPage() {
  return <div>
      <Header />
      <DealsAndSpecialsShowcase />
      <InstagramPromoStrip />
      <Footer />
    </div>;
}